
import { UserContext } from "context";
import { useContext, useEffect } from "react";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { StorageServices } from "utils";
import StorageService from "utils/StorageServices";


const PublicRoute = ({ element, termsAndCondition = false, policy = false, superAdminVerify = false, supplierSheet = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { genrateOtp, token, setToken, setUserData } = useContext(UserContext)
  let isAuthenticated = token
  const searchParams = new URLSearchParams(location.search);
  const redirect_url = searchParams.get("redirect");

  useEffect(() => {

    if (superAdminVerify || supplierSheet) {
      console.log("🔄 SuperAdmin route detected, clearing old session...");
      StorageService.clearStorage();
      setToken(null);
      setUserData(null);
    }

    if (!genrateOtp && !isAuthenticated && !superAdminVerify && !supplierSheet) {
      navigate("/");

      if (termsAndCondition) {
        navigate("/term_policy");

      }
      if (policy) {
        navigate("/policy");

      }

    } 

    if (superAdminVerify) {
      navigate(`/sverify/${id}`);
    }

    if (supplierSheet) {
      navigate(`/7346756734545645646?redirect=${redirect_url}`);
    }

  }, [navigate, genrateOtp, isAuthenticated, termsAndCondition, policy, superAdminVerify, id,supplierSheet])

  return !isAuthenticated ? element : <Navigate to="/dashboard" />;
};

export default PublicRoute

